import { Col, Form, Input, Row, Select, Spin } from "antd";
import "antd/dist/antd.min.css";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { getRequest, patchRequest, postRequest } from "../../../axios";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import "../../../styles/Main.scss";
import { authUserData } from "../../../utils/Helper";
import {
  SuccessNotificationMsg,
} from "../../../utils/Notifications";

const { Option } = Select;

const Deliveryrate = ({
  handleCancel,
  setReload,
  deliveryratesID,
  modalKey,
  setStateM,
}) => {
  const { t } = useTranslation();
  const formRef = useRef();
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setapiLoading] = useState(false);
  const [zones, setZones] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [unitofmeasurement, setunitofmeasurement] = useState([]);
  const [Tounitofmeasurement, setTounitofmeasurement] = useState([]);
  const [company, setcompany] = useState();

  const initialState = {
    price: null,
    company: null,
    start_weight: null,
    start_weight_unit_of_measurement: null,
    end_weight: null,
    end_weight_unit_of_measurement: null,
    country: authUserData()?.country ? authUserData()?.country : 1,
    state: authUserData()?.state ? authUserData()?.state : 1,
    suburb: null,
    zone: null,
    currency: authUserData()?.currency || 'AUD',
   // rate: "variable_rate", // Default value
  };

  const [state, setState] = useState(initialState);
 
  useEffect(() => {
    getCountryName();
    authUserData()?.country
      ? getStateByCountry(authUserData()?.country)
      : getStateByCountry(1);
    authUserData()?.country
      ? getCurrencyByCountry(authUserData()?.country)
      : getCurrencyByCountry(1);
    authUserData()?.state
      ? getZoneByState(authUserData()?.state)
      : getZoneByState(1);

  }, []);

  useEffect(() => {
    getunitofmeasurement();
    getcompany();
    getunitofmeasurementEnd();
  }, []);

  useEffect(() => {
    const fetchzoneById = async () => {
      if (deliveryratesID !== null) {
        try {
          setapiLoading(true);
          const response = await getRequest(
            `delivery-rates/${deliveryratesID}/`
          );

          if (response.data.success) {
            const {
              id,
              country_name,
              state_name,
              zone_name,
              state_code,
              country_code,

              ...filteredResponse
            } = response.data.data;
            setState((prevState) => {
              return {
                ...filteredResponse,
              };
            });

            formRef.current.setFieldsValue({
              ...response.data.data,
              state: response.data.data.state_name,
              country: response.data.data.country_name,
              zone: response.data.data.zone_name,
              currency: response.data.data.currency,
              company: response.data.data.company,
              start_weight: response.data.data.start_weight,
              start_weight_unit_of_measurement:
                response.data.data.start_weight_unit_of_measurement,
              end_weight: response.data.data.end_weight,
              end_weight_unit_of_measurement:
                response.data.data.end_weight_unit_of_measurement,
              price: response.data.data.price,
            });
            getStateByCountry(response?.data?.data?.country);
            getZoneByState(response?.data?.data?.state);
            setapiLoading(false);
          }
        } catch (error) {
          console.error("Error fetching zone:", error);
          setapiLoading(false);
        }
      }
    };
    if (deliveryratesID !== null) {
      fetchzoneById();
    }
  }, [deliveryratesID, modalKey]);

  const getCountryName = async () => {
    try {
      setapiLoading(true);
      const response = await getRequest("country/?no_pagination=True");

      const { data } = response.data;

      setCountries(data);
      formRef.current.setFieldsValue(response.data.data);
      setapiLoading(false);
    } catch (error) {
      setapiLoading(false);
    }
  };

  const handleCountrySelectChange = (value) => {
    setState((prevState) => {
      return {
        ...prevState,
        country: value,
        state: null,
      };
    });
    formRef.current.setFieldsValue({ state: null });
    setStates([]);
    getStateByCountry(value);
    getCurrencyByCountry(value);
  };
  const getStateByCountry = async (id) => {
    const stateResponse = await getRequest(
      "state/?no_pagination=true&country_id=" + id
    );

    setStates(stateResponse?.data?.data);
  };

  const getCurrencyByCountry = async (id) => {
    const stateResponse = await getRequest(
      "country/get-currency/?country_id=" + id
    );

    setState((prevState) => ({
      ...prevState,
      currency: stateResponse?.data?.data[0]?.currency,
    }));
    formRef.current.setFieldsValue({
      currency: stateResponse?.data?.data[0]?.currency,
    });
  };

  const handleStateSelectChange = (value) => {
    setState((prevState) => ({
      ...prevState,
      state: value,
      zone: null,
      suburb: null,
    }));
    formRef.current.setFieldsValue({ zone: null, suburb: null });
    setZones([]);
    getZoneByState(value);
  };
  const getZoneByState = async (id) => {
    const zoneResponse = await getRequest(
      "zone/?no_pagination=true&state_id=" + id
    );

    setZones(zoneResponse?.data?.data);
  };

  const handlezoneChange = (value) => {
    const selectedZone = zones.find((zone) => zone.id === value);
    const zoneName = selectedZone ? selectedZone.zone : "";
    setState((prevState) => ({
      ...prevState,
      zone: value,
      zone_name: zoneName,
     
    }));
 
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        backToList();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  });

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };
  
  const backToList = () => {
    setState(initialState);
    formRef.current.setFieldsValue(initialState);
    authUserData()?.state
      ? getZoneByState(authUserData()?.state)
      : getZoneByState(1);
    setZones([]);
    handleCancel();
  };

  const handlecompany = (value) => {
    setState((prevState) => {
      return {
        ...prevState,
        company: value,
      };
    });

  };

  const getcompany = async (data) => {
    await getRequest("company/?no_pagination=True", data).then((response) => {
      setcompany(response?.data?.data);
    });
  };

  const handlestartunitofmeasurementChange = (value) => {
    setState((prevState) => {
      return {
        ...prevState,
        start_weight_unit_of_measurement: value,
      };
    });
  };

  const handleendunitofmeasurementChange = (value) => {
    setState((prevState) => {
      return {
        ...prevState,
        end_weight_unit_of_measurement: value,
      };
    });
  };
  // const handleOptionChange = (fieldName, value) => {
  //   setState((prevState) => ({
  //     ...prevState,
  //     [fieldName]: value, // Use boolean directly
  //   }));

  // };
  const getunitofmeasurement = async (data) => {
    await getRequest("unit-of-measurement/?no_pagination=True", data).then(
      (response) => {
        setunitofmeasurement(response?.data?.data);
      }
    );
  };

  const getunitofmeasurementEnd = async (data) => {
    await getRequest("unit-of-measurement/?no_pagination=True", data).then(
      (response) => {
        setTounitofmeasurement(response?.data?.data);
      }
    );
  };

  const handleSubmit = async () => {
    try {
      setBtnLoading(true);
      let response;
      const payload = {
        zone: state?.zone,
        country: state?.country,
        state: state?.state,
        company: state?.company,
        start_weight_unit_of_measurement:
          state?.start_weight_unit_of_measurement,
        start_weight: state?.start_weight,
        end_weight_unit_of_measurement: state?.end_weight_unit_of_measurement,
        end_weight: state?.end_weight,
        price: state?.price,
        currency: state?.currency,
      };

      if (deliveryratesID === null) {
        response = await postRequest("delivery-rates/", payload);
      } else {
        response = await patchRequest(
          `delivery-rates/${deliveryratesID}/`,
          payload
        );
      }

      if (response.data.success) {
        SuccessNotificationMsg(
          deliveryratesID === null
            ? t("delivery_rate_added_successfully")
            : t("delivery_rate_updated_successfully")
        );
        setState(initialState);
        setStateM((prev) => ({
          ...prev,
          page: 1,
        }));

        formRef.current.setFieldsValue(initialState);

        setBtnLoading(false);
        handleCancel();
        setReload((reload) => !reload);
      }
    } catch (error) {
      setBtnLoading(false);
    }
  };

  return (
    <>
      <Spin spinning={apiLoading}>
        <Form
          onFinish={handleSubmit}
          autoComplete="off"
          ref={formRef}
          initialValues={state}
        >
             {/* <Col xs={24} sm={24} md={24} lg={24} className="TextFeild">
                <Form.Item
                              className="radioitem"
                              name="rate"
                              label="Select Rate?"
                              initialValue={"variable_rate"}
                              rules={[
                                {
                                  required: true,
                                },
                              ]}
                            >
                              <Radio.Group
                                onChange={(e) =>
                                  handleOptionChange(
                                    "rate",
                                    e.target.value
                                  )
                                }
                                value={state.rate}
                              >
                                <Radio value={"variable_rate"}>Variable Rate</Radio>
                                <Radio value={"flat_rate"}>Flat Rate</Radio>
                              </Radio.Group>
                            </Form.Item>
                            </Col> */}
          <Row gutter={16}>
            
    
            <Col xs={24} sm={12} md={8} lg={12} className="TextFeild">

              <Form.Item
                name="country"
                label={t("pl_country")}
                rules={[
                  {
                    required: true,
                    message: <Trans>{t("val_country")}</Trans>,
                  },
                ]}
              >
                <Select
                  placeholder={t("pl_select_country")}
                  name="country"
                  value={state?.country}
                  showArrow
                  showSearch
                  onChange={handleCountrySelectChange}
                  optionFilterProp="children"
                >
                  {countries.map((country) => (
                    <Option key={country.id} value={country.id}>
                      {country.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={12} className="TextFeild">
              <Form.Item
                name="state"
                label={t("pl_state")}
                rules={[
                  {
                    required: true,
                    message: <Trans>{t("val_select_state")}</Trans>,
                  },
                ]}
              >
                <Select
                  name="state"
                  label={t("pl_state")}
                  placeholder={t("pl_select_state")}
                  value={state?.state}
                  onChange={handleStateSelectChange}
                  showArrow
                  showSearch
                  optionFilterProp="children"
                >
                  {states.map((state) => (
                    <Option key={state.id} value={state.id}>
                      {state.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={12} md={8} lg={12} className="TextFeild">
              <Form.Item
                name="zone"
                label={t("pl_zone")}
                rules={[
                  {
                    required: true,
                    message: <Trans>{t("val_select_zone")}</Trans>,
                  },
                ]}
              >
                <Select
                  name="zone"
                  label={t("pl_zone")}
                  placeholder={t("val_zone")}
                  onChange={handlezoneChange}
                  value={state?.zone}
                  showArrow
                  showSearch
                  optionFilterProp="children"
                >
                  {zones.map((zone) => (
                    <Option key={zone.id} value={zone.id}>
                      {zone.zone}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8} lg={12} className="TextFeild">
              <Form.Item
                name="company"
                label={t("company")}
                placeholder={t("pl_select_company")}
                rules={[
                  {
                    required: true,
                    message: <Trans>{t("val_select_company")}</Trans>,
                  },
                ]}
              >
                <Select
                  placeholder={t("pl_select_company")}
                  showArrow
                  showSearch
                  value={state?.company}
                  name="company"
                  optionFilterProp="children"
                  onChange={(value) => handlecompany(value)}
                >
                  {company?.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.company_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

              {/* {state?.rate === "variable_rate" && <> */}
              <Col xs={24} sm={12} md={8} lg={12} className="TextFeild">
              <Form.Item
                name="start_weight"
                label={t("from_weight")}
                rules={[
                  {
                    // required: true,
                    pattern: /^[0-9]+(\.[0-9]+)?$/,
                    message: <Trans>{t("val_weight_from")}</Trans>,
                  },
                 
                ]}
                initialValue={state?.start_weight}
              >
                <Input
                  
                  name="start_weight"
                  value={state?.start_weight}
                  onChange={handleInputChange}
                  placeholder={t("pl_enter_from_weight")}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={12} className="TextFeild">
              <Form.Item
                name={"start_weight_unit_of_measurement"}
                label={t("label_unit_of_measurement")}
                rules={[
                  {
                    required: false,
                    message: <Trans>{t("val_select_UoM")}</Trans>,
                  },
                ]}
              >
                <Select
                 name={"start_weight_unit_of_measurement"}
                  placeholder={t("pl_unit_of_measurement")}
                  showArrow
                  showSearch
                  value={state?.start_weight_unit_of_measurement}
                 
                  optionFilterProp="children"
                  onChange={(value) =>
                    handlestartunitofmeasurementChange(value)
                  }
                >
                  {unitofmeasurement?.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={12} className="TextFeild">
              <Form.Item
                name="end_weight"
                label={t("to_weight")}
                rules={[
                  {
                    required: false,
                    pattern: /^[0-9]+(\.[0-9]+)?$/,
                    message: <Trans>{t("val_weight_end")}</Trans>,
                  },
                ]}
                initialValue={state?.end_weight}
              >
                <Input
                  type="text"
                  name="end_weight"
                  value={state?.end_weight}
                  onChange={handleInputChange}
                  placeholder={t("pl_enter_weight_end")}
                 
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={12} className="TextFeild">
              <Form.Item
                name="end_weight_unit_of_measurement"
                label={t("label_unit_of_measurement")}
                rules={[
                  {
                    required: false,
                    message: <Trans>{t("val_select_UoM")}</Trans>,
                  },
                ]}
              >
                <Select
                  name="end_weight_unit_of_measurement"
                  placeholder={t("pl_unit_of_measurement")}
                  showArrow
                  showSearch
                  value={state?.end_weight_unit_of_measurement}
                  optionFilterProp="children"
                  onChange={(value) =>
                    handleendunitofmeasurementChange(value)
                  }
                >
                  {Tounitofmeasurement?.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            {/* </>} */}
            <Col xs={24} sm={12} md={8} lg={12} className="TextFeild">
              <Form.Item
                name="price"
                label={t("Price")}
                rules={[
                  {
                    required: true,
                    message: <Trans>{t("pl_enter_price")}</Trans>,
                  },
                  {
                    pattern: /^[0-9]+(\.[0-9]+)?$/,
                    message: <Trans>{t("pl_enter_valid_price")}</Trans>,
                  },
                ]}
              >
                <Input
                  type="text"
                  name="price"
                  value={state?.price}
                  onChange={handleInputChange}
                  placeholder={t("val_enter_price")}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8} lg={12} className="TextFeild">
              <Form.Item
                name="currency"
                label={t("pl_currency")}
                rules={[
                  {
                    required: true,
                    message: <Trans>{t("val_currency")}</Trans>,
                  },
                
                ]}
              >
                <Input
                  type="text"
                  name="currency"
                  value={state.currency}
                  disabled
                  handleInputChange={handleInputChange}
                  placeholder={t("val_currency")}
                />
              </Form.Item>
            </Col>

          </Row>

          <Row gutter={16}>
          </Row>
          <div className="ModalPopupFooter">
            <ButtonField
              className="CancelGradiantBtn"
              type="primary"
              label={t("cancel")}
              onClick={backToList}
            />
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              label={t("save")}
              htmlType="Submit"
              loading={btnLoading}
            />
          </div>
        </Form>
      </Spin>
    </>
  );
};

Deliveryrate.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  setReload: PropTypes.func.isRequired,
  deliveryratesID: PropTypes.number,
  modalKey: PropTypes.bool,
  setStateM: PropTypes.func,
};

export default Deliveryrate;
